import React from "react";

import { RequiredSymbol } from "../common/RequiredSymbol";

const Label = ({
  children,
  className = "",
  isRequired = false,
  htmlFor = "",
}) => {
  let classes = "label ";
  if (className) {
    classes += className;
  }
  return (
    <label className={classes} htmlFor={htmlFor}>
      {children} {isRequired && <RequiredSymbol />}
    </label>
  );
};

export default Label;
